import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useSelector } from "react-redux"
import TopMenus from "../../components/shared/TopMenus"
import KiralikAracArayanlar from "../../components/adminIlanlar/KiralikAracArayanlarAdmin"
import KiralikAraclarAdmin from "../../components/adminIlanlar/KiralikAraclarAdmin"
import IsArayanSuruculerAdmin from "../../components/adminIlanlar/IsArayanSuruculerAdmin"
import SurucuArayanlarAdmin from "../../components/adminIlanlar/SurucuArayanlarAdmin"
import SatilikAraclarAdmin from "../../components/adminIlanlar/SatilikAraclarAdmin"

const Container = styled.div`
  width: 100%;
  height: 100%;
  .top-container{
    margin: 30px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .content{
    margin: 30px;
    display: flex;
    flex-direction: column;
  }
`

const menuData = [
  {
    id:0,
    text:"Kiralık Araç Arayan Firmalar"
  },
  {
    id:1,
    text:"Kiralık Araçlar"
  },
  {
    id:2,
    text:"İş Arayan Sürücüler"
  },
  {
    id:3,
    text:"Sürücü Arayanlar"
  },
  {
    id:4,
    text:"Satılık Araçlar"
  }
]

const titles = ["Oluşturulma Tarihi", "Kaydeden Ad Soyad", "Sürücü Ad Soyad" ,"Yükleme", "Boşaltma", "Yük", "Araç"]

const AdminIlanlar = () => {
  const dispatch = useDispatch()
  const {} = useSelector((state) => state.admin3)
  const [currentPage, setCurrentPage] = useState(1)
  const [activeMenuId, setActiveMenuId] = useState(0)

//   const itemsPerPage = 10;

//   const totalPages = Math.ceil(allShipmentListCount / itemsPerPage);

//   useEffect(() => {
//     dispatch(getShipmentListAdmin({page: currentPage, shipment: activeMenuId}))
//   }, [currentPage, activeMenuId])


  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"İlanlar"} position="sticky" />

        <div className="content">

          <TopMenus menuList={menuData} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />

          {
            activeMenuId === 0 &&
            <KiralikAracArayanlar />
          }
          {
            activeMenuId === 1 &&
            <KiralikAraclarAdmin />
          }
          {
            activeMenuId === 2 &&
            <IsArayanSuruculerAdmin />
          }
          {
            // //!
            activeMenuId === 3 &&
            <SurucuArayanlarAdmin />
          }
          {
            activeMenuId === 4 &&
            <SatilikAraclarAdmin />
          }
          
        </div>

        {/* {(allShipmentList || allShipmentList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )} */}
      </div>
    </Container>
  )
}

export default AdminIlanlar